import React from 'react'

export default function SupportDocs() {
  return <div>SupportDocs</div>
}
